(function () {
    'use strict';

    angular
        .module('tikonApp')
        .factory('AgentRequestSearch', AgentRequestSearch);

    AgentRequestSearch.$inject = ['$resource'];

    function AgentRequestSearch($resource) {
        var resourceUrl = 'api/_search/agent-requests/:id';

        return $resource(resourceUrl, {}, {
            'query': {method: 'GET', isArray: true}
        });
    }
})();
